module.exports = __webpack_public_path__ + "img/empnv.69cb9dfd.png";